import { c as _c } from "react/compiler-runtime";
import { failedAddReminderMessage, successAddReminderMessage } from "@website/accommodation-ui/tour-reminder/constants";
import { updateReminders } from "@website/accommodation-ui/tour-reminder/queries";
import { removeReminder } from "@website/accommodation-ui/tour-reminder/reminder-switch-box/queries";
import { UpdateReminderBody } from "@website/accommodation-ui/tour-reminder/types";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { SnackbarSeverity } from "@website/ui/snackbar-v2";
import { useLoginModal } from "@website/widget/login";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { useState } from "react";
interface Properties {
  reminderId?: number;
  reminderArray?: Array<UpdateReminderBody>;
  refetch: () => Promise<void>;
  origin: string;
  dest: string;
  stDate: string;
  rtDate: string;
}

//TODO: what is replacement for useSnackbar
export function useReminderSwitchBox(t0) {
  const $ = _c(35);
  const {
    reminderId: defaultReminderId,
    reminderArray,
    refetch,
    origin,
    dest,
    stDate,
    rtDate
  } = t0;
  const router = useRouter();
  const {
    openReminderModal
  } = router.query;
  const [activeReminder, setActiveReminder] = useState(false);
  const {
    isLoggedIn
  } = useLoginStatus();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      title: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [snackbar, setSnackbar] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSnackbar({
        title: ""
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onCloseSnackbar = t2;
  let t3;
  if ($[2] !== defaultReminderId || $[3] !== dest || $[4] !== origin || $[5] !== refetch || $[6] !== router || $[7] !== rtDate || $[8] !== stDate) {
    t3 = () => {
      if (defaultReminderId && defaultReminderId >= 3) {
        router.replace({
          pathname: router.pathname,
          query: {
            ...router.query,
            openReminderModal: true
          }
        });
      } else {
        updateReminders({
          destination: dest as string,
          from: stDate as string,
          origin: origin as string,
          product: "TOUR",
          property_id: 0,
          room_id: 0,
          to: rtDate as string,
          type: "AVAILABILITY"
        }).then(() => {
          setActiveReminder(true);
          setSnackbar({
            title: successAddReminderMessage,
            severity: "success"
          });
          refetch();
        }).catch(() => {
          setSnackbar({
            title: failedAddReminderMessage,
            severity: "error"
          });
        });
      }
    };
    $[2] = defaultReminderId;
    $[3] = dest;
    $[4] = origin;
    $[5] = refetch;
    $[6] = router;
    $[7] = rtDate;
    $[8] = stDate;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const addReminder = t3;
  let t4;
  if ($[10] !== router) {
    t4 = () => {
      router.replace({
        pathname: router.pathname,
        query: {
          ...omit(router.query, "openReminderModal")
        }
      });
    };
    $[10] = router;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onCloseModal = t4;
  let t5;
  if ($[12] !== dest || $[13] !== origin || $[14] !== reminderArray || $[15] !== rtDate || $[16] !== stDate) {
    t5 = reminderArray?.filter(item => item.from === stDate && item.to === rtDate && item.origin === origin && item.destination === dest);
    $[12] = dest;
    $[13] = origin;
    $[14] = reminderArray;
    $[15] = rtDate;
    $[16] = stDate;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const hasNotif = t5;
  const {
    onLoginModalOpen
  } = useLoginModal();
  let t6;
  if ($[18] !== activeReminder || $[19] !== addReminder || $[20] !== dest || $[21] !== hasNotif || $[22] !== isLoggedIn || $[23] !== onLoginModalOpen || $[24] !== origin || $[25] !== refetch || $[26] !== rtDate || $[27] !== stDate) {
    t6 = () => {
      if (isLoggedIn) {
        if (hasNotif && hasNotif?.length > 0 || activeReminder) {
          removeReminder({
            destination: dest as string,
            from: stDate as string,
            origin: origin as string,
            product: "TOUR",
            property_id: 0,
            room_id: 0,
            to: rtDate as string,
            type: "AVAILABILITY"
          }).then(() => {
            setActiveReminder(false);
            setSnackbar({
              title: "\u0627\u0639\u0644\u0627\u0646 \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u063A\u06CC\u0631\u0641\u0639\u0627\u0644 \u0634\u062F.",
              severity: "success"
            });
            refetch();
          });
        } else {
          addReminder();
        }
      } else {
        onLoginModalOpen();
        refetch();
      }
    };
    $[18] = activeReminder;
    $[19] = addReminder;
    $[20] = dest;
    $[21] = hasNotif;
    $[22] = isLoggedIn;
    $[23] = onLoginModalOpen;
    $[24] = origin;
    $[25] = refetch;
    $[26] = rtDate;
    $[27] = stDate;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  const onClickReminder = t6;
  const t7 = hasNotif && hasNotif.length > 0 || activeReminder;
  const t8 = Boolean(openReminderModal);
  let t9;
  if ($[29] !== onClickReminder || $[30] !== onCloseModal || $[31] !== snackbar || $[32] !== t7 || $[33] !== t8) {
    t9 = {
      onClickReminder,
      isActiveReminder: t7,
      openModal: t8,
      onCloseModal,
      snackbar,
      onCloseSnackbar
    };
    $[29] = onClickReminder;
    $[30] = onCloseModal;
    $[31] = snackbar;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
}